import React from 'react'
import { Redirect, Route } from 'react-router'
import { InviteRegister } from './invite-register'

// Accepting an invitation signs the person in and lands them like any
// sign-in; the old "Register Success" page is gone and its address (old
// bookmarks, old builds) goes to the landing.
export const InviteLayout = () => {
  return (
    <React.Fragment>
      <Route path="/public/invite/register/:key" component={InviteRegister} />
      <Route exact path="/public/invite/register" component={InviteRegister} />
      <Route path="/public/invite/success">
        <Redirect to="/" />
      </Route>
    </React.Fragment>
  )
}
